import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import SingleStepEventEncounter from '@/features/sports/components/global/SingleStepEventEncounter.vue';

import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { SportEventV2 } from '@/@types/graphql-types';
import { SingleStepContext, contextIs } from '@/features/sports/helpers/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleStepEventEncounterList',
  props: {
    context: null,
    events: null,
    isDataLoading: { type: Boolean },
    timeGroup: null
  },
  setup(__props: any) {

const props = __props as {
	context: SingleStepContext;
	events: SportEventV2[];
	isDataLoading: boolean;
	timeGroup: keyof typeof sportEventsSubheading;
};

const sportEventsSubheading = {
	upcoming: 'SPORTS_WEBAPP_HEADER_SPORT_EVENTS_UPCOMING',
	live: 'SPORTS_WEBAPP_HEADER_SPORT_EVENTS_LIVE',
	today: 'SPORTS_WEBAPP_HEADER_SPORT_EVENTS_TODAY',
	past: 'SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_PAST',
} as const;

const competitionEventsSubheading = {
	upcoming: 'SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_UPCOMING',
	live: 'SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_LIVE',
	today: 'SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_TODAY',
	past: 'SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_PAST',
} as const;



const sportContext = computed(() => [new SnowplowSportContext(props.context.sportType, props.context.pageType)]);
const subheadings = computed(() =>
	contextIs.competition(props.context) ? competitionEventsSubheading : sportEventsSubheading
);

function getSubheading(eventTimeGroup: keyof typeof sportEventsSubheading) {
	return subheadings.value[eventTimeGroup];
}

const domainSessionId = ref<string | null>(null);
onMounted(async () => (domainSessionId.value = await TrackingHelper.getDomainSessionId()));

return { __sfc: true,sportEventsSubheading, competitionEventsSubheading, props, sportContext, subheadings, getSubheading, domainSessionId, HiddenHorizontalScrollbar, SingleStepEventEncounter }
}

})